import _ from 'lodash'

export const durationMixin = {
  methods: {
    formatDuration: function(period) {
      if (_.isNil(period)) {
        return period
      }
      const yearsMatches = period.match(/\d*Y/)
      const monthsMatches = period.match(/\d*M/)
      const years = _.isNil(yearsMatches) ? null : _.head(yearsMatches).replace('Y', '')
      const months = _.isNil(monthsMatches) ? null : _.head(monthsMatches).replace('M', '')
      let yearsFormatted = ''
      let monthsFormatted = ''
      if (years === '1') {
        yearsFormatted = '1 year'
      } else if (years > 0) {
        yearsFormatted = `${years} years`
      }
      if (months === '1') {
        monthsFormatted = `1 month`
      } else if (months > 0) {
        monthsFormatted = `${months} months`
      } else if (_.isEmpty(yearsFormatted)) {
        monthsFormatted = '<1 month'
      }
      let result
      if (!_.isEmpty(yearsFormatted) && !_.isEmpty(monthsFormatted)) {
        result = `${yearsFormatted}, ${monthsFormatted}`
      } else if (!_.isEmpty(yearsFormatted)) {
        result = yearsFormatted
      } else {
        result = monthsFormatted
      }
      return result
    }
  }
}
